import EntityBase from '@/data/EntityBase';

export default class HourStatsRequestsState extends EntityBase({
  updating: 0,
}) {}
